module.exports = __webpack_public_path__ + "static/img/kx.dd9efb28.png";